const BASE_URL = 'https://henkassets.ams3.digitaloceanspaces.com/assets/Images/emersya/cabinets-without-background';

const FRAME_FINISH_MAP = {
  'S9016': 'W',
  'S9005': 'B',
  'S8011': 'FT8011',
};

const SHELF_VALUE_MAP = {
  'Plank 110cm':  '110',
  'Plank 200cm':  '200',
  'Plank 290cm':  '290',
  'Plank 2x 110': '2x110',
  'Geen plank':   'no_shelf',
};

customElements.define(
  'studio-henk-cabinet-modular-viewer',
  class StudioHenkCabinetModularViewer extends HTMLElement {
    connectedCallback() {
      this._imgEl = this.querySelector('.viewer__image');
      this._placeholder = this.querySelector('.viewer__placeholder');

      this._onStateUpdate = () => this._update();
      window.addEventListener('lt-state-update', this._onStateUpdate);

      if (window._ltState) this._update();
    }

    disconnectedCallback() {
      window.removeEventListener('lt-state-update', this._onStateUpdate);
    }

    _getSteps() {
      return document.querySelector('logic-configurator')?.configuration?.steps || [];
    }

    _getSelectedCode(step) {
      if (!step?.value) return null;
      const match = (step.possibleValues || []).find(v => v.key === step.value);
      return match ? (match.code || null) : null;
    }

    _getSelectedLabel(step) {
      if (!step?.value) return null;
      const match = (step.possibleValues || []).find(v => v.key === step.value);
      return match ? (match.value || null) : null;
    }

    _buildMcPath(steps) {
      const byDesc = {};
      steps.forEach(s => {
        const desc = s.description || '';
        if (!byDesc[desc]) byDesc[desc] = s;
      });

      // 1. frameType: strip "MC-" prefix from label (e.g. "MC-4L" → "4L")
      const frameAddStep = byDesc['Modular Cabinet - toevoegen frame'];
      const frameAddLabel = this._getSelectedLabel(frameAddStep);
      const frameType = frameAddLabel ? frameAddLabel.replace('MC-', '').replace('SA', '') : null;

      // 2. frameFinish: map API code via FRAME_FINISH_MAP
      const frameFinStep = byDesc['Frame afwerking'];
      const frameFinCode = this._getSelectedCode(frameFinStep);
      const frameFinish = frameFinCode ? (FRAME_FINISH_MAP[frameFinCode] || null) : null;

      // 3. elementWidth: label is the width directly ("200", "290")
      const breedteStep = byDesc['Breedte'];
      const elementWidth = this._getSelectedLabel(breedteStep);

      // 4. shelfFinish: strip letter prefix from code (e.g. "O3062" → "3062")
      const houtStep = byDesc['Afwerking'];
      const houtCode = this._getSelectedCode(houtStep);
      const shelfFinish = houtCode ? houtCode.replace(/^[A-Z]+/, '') : null;

      // 5. numOakElements: extract leading number from label, default "0"
      const oakStep = byDesc['Modular Cabinet - toevoegen eiken element'];
      let numOak = '0';
      if (oakStep?.value) {
        const label = this._getSelectedLabel(oakStep) || '';
        const m = label.match(/^(\d+)/);
        if (m) numOak = m[1];
      }

      // 6. Configurable shelf rows (>1 option = user-selectable), sorted by row number
      const shelfSteps = steps
        .filter(s => (s.description || '').startsWith('Indeling planken') &&
                     (s.possibleValues || []).length > 1)
        .sort((a, b) => {
          const na = parseInt(a.description.replace(/\D/g, ''), 10);
          const nb = parseInt(b.description.replace(/\D/g, ''), 10);
          return na - nb;
        });

      const shelfParts = shelfSteps.map(s => {
        const label = this._getSelectedLabel(s);
        return label ? (SHELF_VALUE_MAP[label] ?? null) : null;
      });

      const parts = [frameType, frameFinish, elementWidth, shelfFinish, numOak, ...shelfParts];

      const values = { frameType, frameFinish, elementWidth, shelfFinish, numOak, shelfParts };
      const missing = Object.entries(values).filter(([, v]) =>
        Array.isArray(v) ? v.some(p => p === null || p === undefined || p === '') : (v === null || v === undefined || v === '')
      ).map(([k]) => k);

      console.group('[MC-viewer] pad opbouwen');
      console.table(values);
      if (missing.length) console.warn('[MC-viewer] ontbrekende segmenten:', missing);
      console.groupEnd();

      if (missing.length || parts.some(p => p === null || p === undefined || p === '')) return null;

      return 'MC-' + parts.join('-') + '.png';
    }

    _update() {
      const steps = this._getSteps();
      const filename = this._buildMcPath(steps);

      if (!filename) return;

      const url = `${BASE_URL}/${filename}`;
      console.log('[MC-viewer] URL:', url);
      this._showImage(url);
    }

    _showImage(url) {
      if (!this._imgEl) return;
      this._currentImgUrl = url;
      this._imgEl.onerror = () => {
        console.warn('[MC-viewer] afbeelding niet gevonden:', url);
        this._imgEl.hidden = true;
        if (this._placeholder) this._placeholder.hidden = false;
      };
      this._imgEl.onload = () => {
        this._imgEl.hidden = false;
        if (this._placeholder) this._placeholder.hidden = true;
      };
      this._imgEl.src = url;
    }

    get currentImageUrl() {
      return (!this._imgEl?.hidden && this._currentImgUrl) ? this._currentImgUrl : null;
    }
  }
);
